module.exports = __webpack_public_path__ + "static/media/FIU_Engagement.6dc6f7e7.svg";